import { useState } from "react";
import {
  defaultVerifSettingPemakaian,
  defaultVerifSettingPengecekan,
} from "../../utils/editorHelpers";

// The verif settings of the signature boxes (who may sign).
// NOTE: the audit page never loads them (the calls of fetchVerifSettingPengecekan / fetchVerifSettingPemakaian
// were commented out in the original page), so the signature boxes work with the default settings.
// The fetch functions are kept here for when they are turned on again.
const useEditorVerifSetting = ({ uiContext, employee, requestGet }) => {
  const [verifSettingPengecekan, setVerifSettingPengecekan] = useState({
    ...defaultVerifSettingPengecekan,
  });
  const [verifSettingPemakaian, setVerifSettingPemakaian] = useState({
    ...defaultVerifSettingPemakaian,
  });

  const fetchVerifSettingPengecekan = async () => {
    requestGet({
      fullUrl: "/api/masterdata/verifsetting/data",
      params: { filter: `label:contains:audit_kendaraan%` },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        if (data && data.length > 0) {
          const newVerifSetting = {
            ...defaultVerifSettingPengecekan,
            jabatan_id: employee.jabatan_id,
          };
          if (data) {
            for (const verifData of data) {
              const { id, label, jabatan_id } = verifData;
              const newVerifLabel = label
                .replace(`audit_kendaraan:`, "")
                .trim();
              newVerifSetting[newVerifLabel].push(jabatan_id);
            }
          }
          setVerifSettingPengecekan(newVerifSetting);
        }
      },
    });
  };

  const fetchVerifSettingPemakaian = async () => {
    requestGet({
      fullUrl: "/api/masterdata/verifsetting/data",
      params: { filter: `label:contains:pemakaian_mobil%` },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        if (data && data.length > 0) {
          const newVerifSetting = {
            ...defaultVerifSettingPemakaian,
            jabatan_id: employee.jabatan_id,
          };
          if (data) {
            for (const verifData of data) {
              const { id, label, jabatan_id } = verifData;
              const newVerifLabel = label
                .replace(`pemakaian_mobil:`, "")
                .trim();
              newVerifSetting[newVerifLabel].push(jabatan_id);
            }
          }
          setVerifSettingPemakaian(newVerifSetting);
        }
      },
    });
  };

  return {
    verifSettingPengecekan,
    verifSettingPemakaian,
    fetchVerifSettingPengecekan,
    fetchVerifSettingPemakaian,
  };
};

export default useEditorVerifSetting;
